    @for (item of visibleItems; track item.route) {
      <button
        pButton
        type="button"
        [label]="item.label"
        [icon]="item.icon"
        [severity]="item.route === activeRoute ? undefined : 'secondary'"
        [outlined]="item.route !== activeRoute"
        [routerLink]="item.route">
      </button>
    }